import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export async function getFeedbackSubmissions(payload: {
  pageNo?: number;
  pageSize?: number;
  search?: string;
  formId?: string;
  projectId?: string;
  source?: string;
  organizationId?: string;
}) {
  const page = payload.pageNo ?? 0;
  const limit = payload.pageSize ?? 25;
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    search: payload.search || "",
  });
  if (payload.formId) params.set("formId", payload.formId);
  if (payload.projectId) params.set("projectId", payload.projectId);
  if (payload.source) params.set("source", payload.source);
  if (payload.organizationId) params.set("organizationId", payload.organizationId);

  const callParams = await getCallParams("GET");
  return makeCall(
    `${urls.url_prod}/feedback/submissions?${params.toString()}`,
    callParams
  );
}

export async function getFeedbackFormCounts() {
  const callParams = await getCallParams("GET");
  return makeCall(`${urls.url_prod}/feedback/form-counts`, callParams);
}

export async function getFeedbackForms() {
  const callParams = await getCallParams("GET");
  return makeCall(`${urls.url_prod}/feedback/forms`, callParams);
}
